import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      createdAt: 1747911597174,
      object: 'calculateForMaxPeriodWithoutBankMixDetailsByDetails',
      success: true,
      data: {
        sortedMixesByRisk: [
          {
            maxPeriod: 30,
            minPeriod: 12,
            mixes: [
              {
                period: 12,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 3667.813008376235,
                totalReturn: 528165.0732061767,
                returnConversion: 1.320412683015442,
                bankTotalReturn: 537593.0424278227,
              },
              {
                period: 13,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 3460.092758815783,
                totalReturn: 539774.4703752624,
                returnConversion: 1.3494361759381561,
                bankTotalReturn: 550119.7155013549,
              },
              {
                period: 14,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 3282.939851153446,
                totalReturn: 551533.8949937792,
                returnConversion: 1.378834737484448,
                bankTotalReturn: 562816.4069087664,
              },
              {
                period: 15,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 3130.235597958015,
                totalReturn: 563442.4076324422,
                returnConversion: 1.4086060190811054,
                bankTotalReturn: 575681.9034284356,
              },
              {
                period: 16,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2997.390661926504,
                totalReturn: 575499.0070898888,
                returnConversion: 1.438747517724722,
                bankTotalReturn: 588714.9134912597,
              },
              {
                period: 17,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2880.895254817435,
                totalReturn: 587702.6319827554,
                returnConversion: 1.4692565799568884,
                bankTotalReturn: 601914.0695067928,
              },
              {
                period: 18,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2778.019270451038,
                totalReturn: 600052.1624174247,
                returnConversion: 1.5001304060435618,
                bankTotalReturn: 615277.9303028221,
              },
              {
                period: 19,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2686.60711288733,
                totalReturn: 612546.4217383116,
                returnConversion: 1.5313660543457792,
                bankTotalReturn: 628804.9836700988,
              },
              {
                period: 20,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2604.9340764479575,
                totalReturn: 625184.1783475112,
                returnConversion: 1.562960445868778,
                bankTotalReturn: 642493.6490035416,
              },
              {
                period: 21,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2531.603760279153,
                totalReturn: 637964.147590346,
                returnConversion: 1.594910368975865,
                bankTotalReturn: 656342.2800311308,
              },
              {
                period: 22,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2465.4734609900215,
                totalReturn: 650884.9937013678,
                returnConversion: 1.6272124842534195,
                bankTotalReturn: 670349.167621507,
              },
              {
                period: 23,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2405.5990282794537,
                totalReturn: 663945.3318051288,
                returnConversion: 1.659863329512822,
                bankTotalReturn: 684512.5426612478,
              },
              {
                period: 24,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2351.1935068269377,
                totalReturn: 677143.7299661543,
                returnConversion: 1.6928593249153858,
                bankTotalReturn: 698830.5789926534,
              },
              {
                period: 25,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2301.595704274325,
                totalReturn: 690478.7112822959,
                returnConversion: 1.7261967782057397,
                bankTotalReturn: 713301.3964029601,
              },
              {
                period: 26,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2256.2460128710563,
                totalReturn: 703948.7560157701,
                returnConversion: 1.7598718900394252,
                bankTotalReturn: 727923.0636558471,
              },
              {
                period: 27,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2214.6676041857395,
                totalReturn: 717552.3037561832,
                returnConversion: 1.7938807593904582,
                bankTotalReturn: 742693.6015561905,
              },
              {
                period: 28,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2176.451653600514,
                totalReturn: 731287.7556097726,
                returnConversion: 1.8282193890244316,
                bankTotalReturn: 757610.9860392355,
              },
              {
                period: 29,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2141.2456218657708,
                totalReturn: 745153.4764092885,
                returnConversion: 1.8628836910232212,
                bankTotalReturn: 772673.1512752865,
              },
              {
                period: 30,
                risk: 0,
                creditPro: true,
                utilizedRepaymentCapacity: 2108.743880385638,
                totalReturn: 759147.7969388318,
                returnConversion: 1.8978694923470796,
                bankTotalReturn: 787877.9927815029,
              },
            ],
            risk: '0',
          },
          {
            maxPeriod: 30,
            minPeriod: 13,
            mixes: [
              {
                period: 13,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 3332.898167586128,
                totalReturn: 555943.9472068764,
                returnConversion: 1.389859868017191,
                bankTotalReturn: 569188.835448294,
              },
              {
                period: 14,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 3154.283422722344,
                totalReturn: 569653.257808892,
                returnConversion: 1.42413314452223,
                bankTotalReturn: 584177.8967812792,
              },
              {
                period: 15,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 3000.137060065216,
                totalReturn: 583637.8785104422,
                returnConversion: 1.4590946962761056,
                bankTotalReturn: 599483.7514144706,
              },
              {
                period: 16,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2865.8674904150894,
                totalReturn: 597902.4130234597,
                returnConversion: 1.4947560325586493,
                bankTotalReturn: 615111.7567682355,
              },
              {
                period: 17,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2747.963284763854,
                totalReturn: 612451.5846716992,
                returnConversion: 1.531128961679248,
                bankTotalReturn: 631067.4080689398,
              },
              {
                period: 18,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2643.6931352813526,
                totalReturn: 627290.242443166,
                returnConversion: 1.568225606107915,
                bankTotalReturn: 647356.3458161189,
              },
              {
                period: 19,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2550.9005657014022,
                totalReturn: 642423.3672441305,
                returnConversion: 1.6060584181103261,
                bankTotalReturn: 663984.3634976394,
              },
              {
                period: 20,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2467.8602288019883,
                totalReturn: 657856.0783556016,
                returnConversion: 1.644640195889004,
                bankTotalReturn: 680957.4155520279,
              },
              {
                period: 21,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2393.17526193304,
                totalReturn: 673593.6400930958,
                returnConversion: 1.6839841002327396,
                bankTotalReturn: 698281.6255771352,
              },
              {
                period: 22,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2325.7026366527134,
                totalReturn: 689641.4686706057,
                returnConversion: 1.7241036716765141,
                bankTotalReturn: 715963.2947844663,
              },
              {
                period: 23,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2264.4979825116943,
                totalReturn: 706005.1392697655,
                returnConversion: 1.7650128481744136,
                bankTotalReturn: 734008.910698477,
              },
              {
                period: 24,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2208.7742050116894,
                totalReturn: 722690.3933153474,
                returnConversion: 1.8067259832883684,
                bankTotalReturn: 752425.156100427,
              },
              {
                period: 25,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2157.8700353558124,
                totalReturn: 739703.1459582658,
                returnConversion: 1.8492578648956643,
                bankTotalReturn: 771218.9182164312,
              },
              {
                period: 26,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2111.2258380338594,
                totalReturn: 757049.4937675116,
                returnConversion: 1.8926237344187788,
                bankTotalReturn: 790397.29814966,
              },
              {
                period: 27,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2068.364794569041,
                totalReturn: 774735.7226325272,
                returnConversion: 1.936839306581318,
                bankTotalReturn: 809967.6205568633,
              },
              {
                period: 28,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 2028.8781193737796,
                totalReturn: 792768.3158778232,
                returnConversion: 1.9819207896945579,
                bankTotalReturn: 829937.4435696878,
              },
              {
                period: 29,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 1992.4133344353827,
                totalReturn: 811153.9625917391,
                returnConversion: 2.027884906479348,
                bankTotalReturn: 850314.5689615293,
              },
              {
                period: 30,
                risk: 1,
                creditPro: true,
                utilizedRepaymentCapacity: 1958.664889093659,
                totalReturn: 829899.5661715502,
                returnConversion: 2.0747489154288754,
                bankTotalReturn: 871107.0525611476,
              },
            ],
            risk: '1',
          },
        ],
        disposableIncome: 25000,
        mortgagePaymentCapacity: 9500,
        fundingPercentage: 46.666666666666664,
      },
    },
    error: {
      response: {
        createdAt: 1701115461239,
        object: 'login',
        success: false,
      },
      status: 500,
    },
  },
};

const calculateHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(1000);
  return HttpResponse.json(response, status);
};

export {
  calculateHandler,
};
